module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0027.jpg?v=a432eadb";